import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export interface Testimonial {
  initials: string;
  name: string;
  location: string;
  text: string;
  color: string;
  pack?: string;
}
interface TestimonialsProps {
  testimonials: Testimonial[];
  title?: string;
  className?: string;
}
export function Testimonials({
  testimonials,
  title,
  className = ''
}: TestimonialsProps) {
  return <section className={`py-16 bg-[#0c241a] ${className}`} data-id="element-316">
      <div className="container mx-auto px-4" data-id="element-317">
        {title && <h2 className="font-bold text-center mb-12 text-white text-[16px] md:text-2xl" data-id="element-318">
            {title}
          </h2>}

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-6xl mx-auto" data-id="element-319">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="bg-[#06140d]/70 p-6 rounded-2xl shadow-lg border border-[#1a3d2c] flex flex-col h-full" data-id="element-320">
              <div className="flex items-center gap-1 mb-4" data-id="element-321">
                {[...Array(5)].map((_, j) => <Star key={j} className="w-4 h-4 text-slate-300 fill-slate-300" data-id="element-322" />)}
              </div>

              <p className="text-slate-300 italic mb-6 flex-grow" data-id="element-323">"{t.text}"</p>

              <div className="flex items-center gap-3 mt-auto pt-4 border-t border-[#1a3d2c]/50" data-id="element-324">
                <div className={`w-10 h-10 rounded-full flex items-center justify-center text-white font-bold text-sm ${t.color}`} data-id="element-325">
                  {t.initials}
                </div>
                <div data-id="element-326">
                  <p className="font-bold text-white text-sm" data-id="element-327">{t.name}</p>
                  <p className="text-xs text-slate-300/80" data-id="element-328">{t.location}</p>
                  {t.pack && <p className="text-xs font-medium text-slate-200 mt-0.5" data-id="element-329">
                      {t.pack}
                    </p>}
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}
export const initialTestimonials: Testimonial[] = [{
  initials: 'CR',
  name: 'Carlos R.',
  location: 'Docente de Topografía · UTN Córdoba',
  text: 'Llevaba años armando mis propias guías de campo desde cero cada cuatrimestre. Abrí el Tomo 2 y en 10 minutos tenía una práctica completa lista para imprimir. No puedo creer que antes perdía 3 horas haciendo esto.',
  color: 'bg-emerald-700'
}, {
  initials: 'MS',
  name: 'Marcela S.',
  location: 'Profesora de Agrimensura · Buenos Aires',
  text: 'El Banco de Evaluaciones me salvó el año. Tengo 500 preguntas organizadas por tema y nivel. Ya no busco más en Google exámenes que mis alumnos ya conocen.',
  color: 'bg-green-800'
}, {
  initials: 'JP',
  name: 'Jorge P.',
  location: 'Docente técnico · Mendoza',
  text: 'El Tomo 6 de Topografía Digital me permitió incorporar Civil 3D y GPS RTK a mis clases sin sentirme obsoleto. Mis alumnos ahora trabajan con herramientas reales de obra.',
  color: 'bg-emerald-800'
}];
export const moreTestimonials: Testimonial[] = [{
  initials: 'PM',
  name: 'Pablo M.',
  location: '🏙️ Buenos Aires',
  text: 'Dos años armando el mismo material cada año. Con el Megapack en una tarde tenía todo el cuatrimestre organizado. No lo puedo creer.',
  color: 'bg-green-900',
  pack: 'Megapack Topografía'
}, {
  initials: 'RL',
  name: 'Roberto L.',
  location: '🏙️ Santa Fe',
  text: 'El Tomo 3 de Cálculo Planimétrico me dio una secuencia tan clara que mis alumnos entendieron la poligonal cerrada en una sola clase. Antes me llevaba tres.',
  color: 'bg-emerald-600',
  pack: 'Megapack Topografía'
}, {
  initials: 'GF',
  name: 'Gabriela F.',
  location: '🏙️ Tucumán',
  text: 'Con las Presentaciones Listas llegué al aula con una clase de GPS RTK profesional. Mis alumnos pensaron que había hecho un curso especial.',
  color: 'bg-emerald-700',
  pack: 'Megapack + Presentaciones'
}, {
  initials: 'AM',
  name: 'Andrés M.',
  location: '🏙️ Rosario',
  text: 'Cerré la planificación anual en 2 horas usando los recursos del Megapack. Antes me llevaba una semana entera.',
  color: 'bg-green-800',
  pack: 'Megapack + Presentaciones'
}, {
  initials: 'SV',
  name: 'Silvia V.',
  location: '🏙️ Córdoba',
  text: 'El Banco de Evaluaciones con clave me cambió la vida. Tengo parciales diferentes para cada comisión y los corrijo en minutos.',
  color: 'bg-emerald-800',
  pack: 'Megapack Topografía'
}];